module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"You have been invited to join the \\"{companyName}\\" account","newPassword":"New password","newPasswordConfirmation":"New password confirmation","join":"Join","firstName":"First name","lastName":"Last name","phone":"Phone","position":"Position","logout":"Logout"}}')
  delete Component.options._Ctor
}
